import { GraphQLClient } from 'graphql-request';
import { getSdk } from '@/api/spotwrite';

const BASE_GRAPHQL_ENDPOINT = process.env.VUE_APP_GRAPHQL_BASE_URL;

export default function useGraphQLClient() {
  const accessToken = localStorage.getItem('accessToken');

  const graphQLClient = new GraphQLClient(BASE_GRAPHQL_ENDPOINT);
  graphQLClient.setHeader('Authorization', `Bearer ${accessToken}`);
  return getSdk(graphQLClient);
}
